export default __webpack_public_path__ + "static/media/Avatar-6.aa0790c7.png";